import api from './api';

export const blogFeedbackService = {
   // blogIds: optional comma-separated ids to limit the summary to
   getSummary: (blogIds) =>
      api.get('/blog-feedback/summary', { params: blogIds ? { blogIds } : {} }),
};
